



















































import {Component, Prop, Vue} from 'vue-property-decorator';
import OverallLine from '@/pages/overall/overall-line/overall-line';
import OverallBar from '@/pages/overall/overall-bar/overall-bar';
import OverallCourse from '@/pages/overall/overall-course/overall-course.vue';
import Course, {Assignment} from '@/logic/course';
import {GPAUtils} from '@/logic/utils/gpa-utils';

@Component({
    components: {OverallLine, OverallBar, OverallCourse}
})
export default class Overall extends Vue
{
    @Prop({required: true}) courses: Course[];

    /**
     * This function is called to get gpa since I can't import another
     * class in the Vue file.
     */
    getGPA()
    {
        return GPAUtils.getGPA(this.courses);
    }

    // For clear unread prompt
    unread: Assignment[];
    clearUnreadPrompt = false;
    dontAskAgain = false;
    started = false;

    /**
     * Mark as read progress
     */
    progress()
    {
        return +(this.unread.filter(a => !a.unread).length / this.unread.length * 100).toFixed(1);
    }

    /**
     * On page load - check if the user has too many notifications
     */
    mounted()
    {
        // Check unread
        if (!this.$cookies.isKey('va.ignore-unread'))
        {
            // Count unread
            this.unread = this.courses.flatMap(c => c.assignments.filter(a => a.unread));

            // Prompt clear
            if (this.unread.length > 15)
            {
                this.clearUnreadPrompt = true;
            }
        }
    }

    /**
     * Clear unread
     *
     * @param confirmed
     */
    clearUnread(confirmed: boolean)
    {
        // Hide prompt
        this.clearUnreadPrompt = false;

        // Not confirmed, do nothing
        if (!confirmed)
        {
            if (!this.dontAskAgain) return;

            // Don't ask again
            this.$cookies.set('va.ignore-unread', true);
            return;
        }

        // Clear unread
        this.started = true;
        this.unread.forEach((a, i) =>
        {
            // Delay: 100ms per assignment
            // I don't want my server to explode lol
            setTimeout(() => a.markAsRead().then(() => this.$forceUpdate()), 100 * i);
        });
    }
}
